import { FC, ReactNode } from 'react'
import styles from './styles.module.scss'

export const Ul: FC<{ children?: ReactNode }> = (props) => (
  <div className={styles.ul} {...props} />
)
